export default __webpack_public_path__ + "static/media/hackwithheart.4edb45c3.png";